import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4498f7b0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4498f7b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498f7b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4498f7b0')) {
      api.createRecord('4498f7b0', component.options)
    } else {
      api.reload('4498f7b0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4498f7b0&scoped=true", function () {
      api.rerender('4498f7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/index.vue"
export default component.exports